import { Swipe } from './Swipe'
export default Swipe
